<template>
  <q-icon
    name="circle"
    color="orange"
    style="position: absolute; top: -6px; right: -6px"
    size="xs"
  ></q-icon>
  <q-icon
    name="circle"
    color="orange"
    style="position: absolute; top: -6px; right: -6px"
    size="xs"
    class="ping-animation"
  ></q-icon>
</template>

<script lang="ts">
export default {
  name: 'PingDot'
}
</script>

<style scoped>
@keyframes ping {
  75%,
  100% {
    transform: scale(2);
    opacity: 0;
  }
}

.ping-animation {
  animation: ping 1.5s cubic-bezier(0, 0, 0.2, 1) infinite;
}
</style>
